export const MetricHighlights = () => {
	return (
		<div className="stats-container">
			<div className="stat-card">
				<h3>Portfolio Value</h3>
				<div className="stats-row">
					<p className="value">$24,650</p>
					<span className="badge positive">↑ 2.4%</span>
				</div>
			</div>
			<div className="stat-card">
				<h3>Yield So Far</h3>
				<div className="stats-row">
					<p className="value">$3,218</p>
					<span className="badge positive">↑ 0.8%</span>
				</div>
			</div>
			<div className="stat-card">
				<h3>Current APY</h3>
				<div className="stats-row">
					<p className="value highlight">14.2%</p>
					<span className="badge positive">↑ 1.2%</span>
				</div>
			</div>
		</div>
	)
}
